import React, { ReactNode, useCallback, useContext, useMemo } from "react";
import "./PageLayout.scss";
import { Text } from "../text/Text";
import Button from "../button/Button";
import { formUrl, listViewUrl, loginUrl } from "../../constants/Routes";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../context/UserContext";
import { useLocation } from "react-router-dom";

interface PageLayoutProps {
  children: ReactNode;
}

const PageLayout = ({ children }: PageLayoutProps) => {
  const navigate = useNavigate();

  const { pathname } = useLocation();
  const { isLoggedIn } = useContext(UserContext);

  const handleClick = useCallback(() => {
    console.log("loggedin", isLoggedIn);
    if (pathname === listViewUrl && isLoggedIn) {
      navigate(formUrl);
    } else if (pathname === listViewUrl) {
      navigate(loginUrl);
    } else if (pathname === formUrl || pathname === loginUrl) {
      navigate(listViewUrl);
    }
  }, [isLoggedIn, navigate, pathname]);

  const buttonText = useMemo<string>(() => {
    return window.location.pathname === listViewUrl ? "Skjema" : "Liste";
  }, []);

  return (
    <div className="page-layout">
      <div className="page-layout__header">
        <Text
          className="title"
          text="Kystverket MRN"
          size="big"
          fontWeight={600}
        />
        <Text className="urn" text="urn:mrn:iho:no01" size="small" />
      </div>
      <div className="page-layout__content">{children}</div>
      {window.location.pathname !== loginUrl && (
        <Button
          className="change-view-btn"
          text={buttonText}
          onClick={handleClick}
        />
      )}
    </div>
  );
};

export default PageLayout;
